module.exports = __webpack_public_path__ + "static/media/img6.38b032f1.jpg";